module.exports = __webpack_public_path__ + "r-v3/img/search_gray.f4c8f47e.svg";